module.exports = {"TXTWCL_View_Full_Race_Card":{"id":"TXTWCL_View_Full_Race_Card","defaultMessage":"Gesamte Rennkarte anzeigen"}}